import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import { DEFAULT_ICON_MARGIN} from "root/Tables/BaseTableComponents";

import {
    TableActionIconView, TableActionIconDelete,
    customHeaderStyle,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultPaginationOptions, TableActionIconAdd
} from "root/Tables/BaseTableComponents";

import IconTooltip from "root/UI/Tooltip/IconTooltip";

const ResourcesTable = (props) => {

    const onClickItem = (resource_id, mode) =>
    {
        props.clickHandler( mode,  resource_id, props.child_uid );
    }

    const getPreviewSrc = (row) =>
    {
        let previewSrc = '';

        // Check if resource is a link or document
        if(row.link === null || row.link === undefined || row.link === ''){
            previewSrc = '/getFile.php?enc_docid=' + row.document_id;
        }
        else{
            previewSrc = row.link;
        }

        return previewSrc;
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <a href={getPreviewSrc(row)} target="_blank" icon="icon-view" style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text='Preview Resource' icon="icon-link" color="var(--s360-icon-blue)"/></a>
                { row.onOff === '1' && <TableActionIconDelete text="Remove Access" onClick={() => onClickItem(row.resource, 'remove')} />}
                { row.onOff === '0' && <TableActionIconAdd text="Add Access" onClick={() => onClickItem(row.resource, 'add')} />}
                <TableActionIconView text="View Resource" onClick={() => onClickItem(row.resource_id, 'view')} />
            </Fragment>
        );
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const color = cell === "0" ? "#E00909" : "#216C06";

        const disp = cell === '1' ? 'On' : 'Off';

        return <div style={{ borderRadius: "5px", color: color }}>{disp}</div>;
    }

    const previewFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <a href={getPreviewSrc(row)} target="_blank" icon="icon-add">Link</a>
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        name: {borderRadius: defaultTopLeftCellStyle},
        description: {width: "15vw"},
        rt_name: {width: "6vw"},
        onOff: {width: "2vw"},
        options: {borderRadius: defaultTopLeftCellStyle, textAlign: 'right', width: "100px"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "name",
                text: "Name",
                sort: true,
                headerStyle: headerStyle,

            },
            {
                dataField: "description",
                text: "Description",
                headerStyle: headerStyle
            },

            {
                dataField: "rt_name",
                text: "Type",
                textAlign: "center",
                headerStyle: headerStyle,
                style: {overflow:'hidden'},
            },
            {
                dataField: "onOff",
                text: "Access",
                textAlign: "center",
                formatter: statusFormatter,
                headerStyle: headerStyle,
                style: {overflow:'hidden'},
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default ResourcesTable;

ResourcesTable.propTypes = {
    post_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};